import { render } from "./video.vue?vue&type=template&id=508b6b9f&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=508b6b9f&lang=less&scoped=true"
import "./video.vue?vue&type=style&index=1&id=508b6b9f&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508b6b9f"]])

export default __exports__